<template>
    <a class="workout-card" @click.prevent="goTo">
        <div class="workout-card__inner">
            <v-lazy-image class="workout-card__image" :src="carddata.coverImageUrl ? carddata.coverImageUrl : carddata.imageUrl"></v-lazy-image>
            <div class="workout-card__content">
                <div v-if="carddata.containsRun" class="workout-card__running running-batch" v-translate>includes_running</div>
                <div class="workout-card__title">{{ carddata.title }}</div>
                <div class="workout-card__subtitle">{{ carddata.subtitle }}</div>
                <div class="workout-card__info" v-if="carddata.difficulty">{{ create_time(carddata) }} — {{ carddata.difficulty.charAt(0).toUpperCase() + carddata.difficulty.slice(1) }} — {{ carddata.trainer.name }}</div>
            </div>

            <div class="workout-card__dimm"></div>
            <div class="workout-card__fulldimm"></div>

            <div class="workout-card__favourite" v-if="isWorkout">
                <FavouriteButton :workoutId="carddata.id"></FavouriteButton>
            </div>
        </div>
    </a>
</template>

<script>
import FavouriteButton from '@/components/FavouriteButton'

export default {
    name: "WorkoutCard",
    components: {
        FavouriteButton
    },
    props: {
        carddata: Object
    },
    computed: {
        isWorkout() {
            return this.carddata.kind === 'Workout' || this.carddata.duration
        },
    },
    methods: {
        create_time(data) {
            var duration = data.duration;
            var mins = duration / 60;
            var hours = Math.floor(mins / 60);

            var retval = mins + ' min';
            if(hours >= 1){
                retval = hours + ' h ' + (mins - (hours * 60)) + ' min';
            }

            return retval;
        },
        goTo() {
            if(this.carddata.url && !this.carddata.url.includes(`share.pumatr.ac`) && !this.carddata.url.includes(`global.puma.com`)) {
                window.open(this.carddata.url, '_blank')
            } else {
                this.$router.push({ name: this.isWorkout ? 'WorkoutOverview' : 'Opportunity', params: { id: this.carddata.id } })
            }
        }
    }
}
</script>

<style lang="scss">
.workout-card {
    $block: &;
    box-sizing: border-box;
    padding: 6px;
    float: left;
    width: 100%;
    cursor: pointer;

    @include mq(tablet) {
        width: 50%;
    }
    @include mq(tablet-landscape) {
        width: 33.33%;
    }
    @include mq(notebook) {
        width: 25%;
    }

    &--full {
        width: 100% !important;
        padding: 0;
        width: 100%;
    }

    &--small {
        #{$block}__inner {
            padding-bottom: 100%;
        }
    }

    &__inner {
        width: 100%;
        position: relative;
        padding-bottom: 125%;
        background-size: cover;
        background-position: center center;
        height: 0;
        border-radius: 4px;
        overflow: hidden;
    }

    &__image {
        @include object-fit;
    }

    &__content {
        position: absolute;
        left: 23px;
        bottom: 23px;
        width: calc(100% - 46px);
        z-index: 10;
    }

    &__running {
        margin-bottom: 15px;
    }

    &__title{
        font-weight: bold;
    }
    &__title,
    &__subtitle {
        color: $puma-color-white;
        display: block;
        text-transform: uppercase;
        font-size: $puma-size-font-2xl;
        line-height: 1.25;
    }

    &__info {
        color: $puma-color-white;
        font-size: $puma-size-font-xs;
        margin-top: 14px;

        @include mq(notebook) {
            font-size: $puma-size-font-sm;
        }
    }

    &__dimm {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
        position: absolute;
        left: 0;
        bottom: 0;
        height: 35%;
        width: 100%;
        z-index: 5;
        transition: all .25s ease;
    }
    &__fulldimm {
        background: black;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        z-index: 6;
        opacity: 0;
        transition: all .25s ease;
    }

    .no-touch &:hover {
        .workout-card {
            &__dimm {
                opacity: .5;
            }
            &__fulldimm {
                opacity: .4;
            }
            &__favourite {
                opacity: 1;
                pointer-events: auto;
            }
        }
    }

    &__favourite {
        position: absolute;
        top: 20px;
        right: 20px;
        line-height: 1;
        z-index: 10;
        color: white;
        opacity: 0;
        pointer-events: none;
        transition: opacity .25s ease;
    }
}
</style>